import React, { useEffect, useState } from 'react';
import { cx } from 'linaria';
import { Typography, Divider } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { useSelector } from 'react-redux';
import { getPath } from 'selectors';
import { GAClickButton } from 'utils';
import { MOBILE_VIEW_SEARCH_PARAM } from 'constants/common';
import { displayMobile, Container, title, StyledLinkButton } from './styles';
import NAVBAR_LINKS from '../../navbar-links.json';
import { LinkProps } from '../types';

const NavbarItem = ({ link, label }: LinkProps) => {
	const path = useSelector(getPath);
	const [isActive, setIsActive] = useState(link === path);

	useEffect(() => {
		setIsActive(link.split('?')[0] === path);
	}, [link, path]);

	const clickHandler = () =>
		GAClickButton({
			elementBlock: 'pravila',
			elementName: 'Правила продажи товаров',
			elementText: label,
		});

	return (
		<>
			<StyledLinkButton
				onClick={clickHandler}
				href={link}
				isActive={isActive}
				className={isActive ? 'navbar-item__active' : ''}
			>
				<Typography variant="m" size="body_long">
					{label}
				</Typography>
				<ChevronRightIcon type="outline" size="m" className={displayMobile} />
			</StyledLinkButton>
			<Divider className={displayMobile} />
		</>
	);
};

export const Navbar = ({ isMobileView = false }) => (
	<Container data-qa={'navbar'}>
		<Typography className={cx(title, displayMobile)} variant="h2" color="text-primary" as="h2">
			Другие темы
		</Typography>
		{NAVBAR_LINKS.map(({ link, label }) => (
			<NavbarItem
				link={link + (isMobileView ? `?${MOBILE_VIEW_SEARCH_PARAM}` : '')}
				label={label}
				key={label}
			/>
		))}
	</Container>
);
